import { Catalog } from '../../reducers'

import { State } from '../../store.types'

export const selectCatalog = (state: State): Catalog => state.app.catalog
